<template>
  <div>
    <b-overlay
      :show="loadTeachers"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="md"
    >
      <div
        class="resetTeachers text-center"
        v-if="maingroupHods.length != 0 && survey_type == 'hod_feedback'"
      >
        <b-button variant="danger" @click="resetHods()" size="sm">
          Clear all
        </b-button>
      </div>

      <div class="d-flex mt-3" style="height: 200px">
        <div class="subgroupNames w-50" style="overflow-y: scroll">
          <b-form-checkbox
            size="sm"
            v-for="(subgroup, index) in subgroupsTeachersOptions"
            :key="index"
            v-model="selectedMaingroupHods"
            :value="subgroup.value"
            :disabled="subgroup.disabled"
            @change="getMaingroupHods(subgroup.value)"
          >
            {{ subgroup.text }}
          </b-form-checkbox>
        </div>

        <div
          class="subgroupTeachers w-50"
          v-if="uniqueMaingroupHods.length != 0"
          style="overflow-y: scroll"
        >
          <div class="users d-flex flex-wrap">
            <p
              v-for="(hod, index) in uniqueMaingroupHods"
              :key="index"
              class="bg-success p-2 text-white rounded ml-2"
              style="font-size: 12px"
            >
              {{ hod.maingroup + ' - ' + hod.hod }}
              <span
                class="text-white btn m-0 p-0"
                @click="removeHod(hod)"
              >
                <i class="far fa-times-circle ml-2"></i>
              </span>
            </p>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  props: ["subgroupsForTeachers", "surveyId", "survey_type"],

  async created() {
    await this.subgroups;
    await this.resetHods();
  },

  data() {
    return {
      loadTeachers: false,
      subgroupsTeachersOptions: this.subgroups,
      selectedMaingroupHods: [],
      maingroupHods: [],
    };
  },

  computed: {
    // ✅ Show only unique items on frontend
    uniqueMaingroupHods() {
      const uniqueMap = new Map();
      this.maingroupHods.forEach((item) => {
        const key = `${item.maingroup_id}_${item.institution_user_id}`;
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, item);
        }
      });
      return Array.from(uniqueMap.values());
    },
  },

  methods: {
    async prepareSyncHodsPostData() {
      const syncHods = await this.syncHodsWithFeedbackSurvey();

      if (syncHods) {
        this.$toast.success(`Linking department hods successfully done.`, {
          position: "top",
          duration: 3000,
        });
      } else {
        this.$toast.error(`Linking course teachers failed, Please try again`, {
          position: "top",
          duration: 3000,
        });
      }
    },

    async syncHodsWithFeedbackSurvey() {
      let syncUrl = this.$store.getters.getAPIKey.studentFeedbackSurveySyncHods;
      const url = syncUrl.replace("survey_id", this.surveyId);
      let status = null;
      await this.$axios
        .post(url, { maingroup_hods: this.maingroupHods })
        .then(() => (status = true))
        .catch(() => (status = false));
      return status;
    },

    async resetHods() {
      this.subgroupsTeachersOptions = [];
      this.selectedMaingroupHods = [];
      this.subgroupsTeachersOptions = this.subgroupsForTeachers;
      this.subgroupsTeachersOptions.forEach((subgroup) => {
        subgroup.disabled = false;
      });
      this.maingroupHods = [];
    },

    async getMaingroupHods(subgroupId) {
      this.loadTeachers = true;

      const selectedIndex = this.selectedMaingroupHods.findIndex(
        (val) => val === subgroupId
      );
      const optionIndex = this.subgroupsTeachersOptions.findIndex(
        (opt) => opt.value === subgroupId
      );

      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroup/${subgroupId}/department/withhods`;

      try {
        const response = await this.$axios.get(url);
        const mainUsers = response.data;

        if (!mainUsers.institution_users || mainUsers.institution_users.length === 0) {
          this.$toast.warning("No HoDs found!", {
            position: "top",
            duration: 3000,
          });
          this.selectedMaingroupHods.splice(selectedIndex, 1);
        } else {
          this.subgroupsTeachersOptions[optionIndex].disabled = true;

          // ✅ Allow duplicates but push all to backend array
          mainUsers.institution_users.forEach((hod) => {
            this.maingroupHods.push({
              maingroup: mainUsers.name,
              maingroup_id: mainUsers.id,
              hod: hod.first_name,
              institution_user_id: hod.id,
              subgroup_id: subgroupId,
            });
          });
        }
      } catch (error) {
        this.$toast.error("Failed to load HoDs", {
          position: "top",
          duration: 3000,
        });
      }

      this.loadTeachers = false;
    },

    removeHod(hodToRemove) {
      // Remove all duplicates of same hod in both arrays
      this.maingroupHods = this.maingroupHods.filter(
        (hod) =>
          !(
            hod.maingroup_id === hodToRemove.maingroup_id &&
            hod.institution_user_id === hodToRemove.institution_user_id
          )
      );
    },
  },
};
</script>
